import React from "react";
import Hero from "./components/Hero";
import Pillars from "./components/Pillars";
import About from "./components/About";
import Methodology from "./components/Methodology";
import CTA from "./components/CTA";

// Página de início. Header e Footer ficam fora deste componente
// (devem envolver <Home /> no layout/App, já que já foram criados antes).
export default function Home() {
  return (
    <main className="home">
      <Hero />
      <Pillars />
      <About />
      <Methodology />
      <CTA />
    </main>
  );
}
